import About from './About'
import './About.scss'

export default About
